import axios, { AxiosResponse } from "axios";
// import { LoginData } from "../store/slices/auth";
// import { AuthResponse, ChangePasswordRequest } from "../interfaces/auth.interface";
// import { store } from "../store";


const authApi = axios.create({
    baseURL: process.env.REACT_APP_AUTH_API,
});

export const loginRequest = async (loginData: {UserName: string, Password: string}) => {
	const resp: AxiosResponse<any> = await authApi.post('/LogonHelp', loginData);
	return resp;
}


// export const recoverPasswordRequest = async (userEmail: string) => {
// 	const resp: AxiosResponse<AuthResponse> = await authApi.post('/SendNewPassword', {
// 		ModuleId: process.env.REACT_APP_MODULE_ID,
// 		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
// 		Email: userEmail,
// 	});
// 	return resp;
// }


// export const changePasswordRequest = async (props: ChangePasswordRequest): Promise<AuthResponse | null> => {
// 	const authCompanySelectedState = store.getState().auth;
// 	const data =  {
// 		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
// 		UserId: authCompanySelectedState?.sessionData?.UserId,
// 		...props,
// 	};
// 	const headers = {
// 		ModuleId: process.env.REACT_APP_MODULE_ID,
// 		Token: authCompanySelectedState.companyselected?.Token,

// 	}
// 	const resp: AuthResponse | null = await authApi
// 					.post('/ChangeUserPassword',data , {headers})
// 					.then( r => r.data as AuthResponse)
// 					.catch(e => {
// 						console.error(e);
// 						return null;
// 					});
// 	return resp;
// }